import axios from 'axios';

const instance = axios.create();

instance.defaults.headers.common['Authorization'] = localStorage.getItem('idToken');

// instance.interceptors.request...

export default instance;